import type { PaginationProps } from 'antd'
import type { FC } from 'react'

import { Pagination } from 'antd'

import NextButton from '../Icons/ButtonPagination/NextButton'
import PrevButton from '../Icons/ButtonPagination/PrevButton'
export interface IPagination {
  total: number
  unfiltered?: number
  defaultPageSize: number
  pageOptions: number[]
  changePage: (page: number, pageSize: number) => void
  current: number
  backColor?: string
  className?: string
}

const PaginationTable: FC<IPagination> = ({
  total,
  unfiltered,
  defaultPageSize,
  pageOptions,
  changePage,
  current,
  backColor,
  className
}) => {
  const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
      return <PrevButton />
    }
    if (type === 'next') {
      return <NextButton />
    }
    return <li className='pagination-item'>{originalElement}</li>
  }
  return (
    <div
      className={`pagination ${backColor === undefined ? '' : backColor} ${
        className === undefined ? '' : className
      }`}
    >
      <div className='total'>
        <div className='total-title'>
          Results: {total}
          {unfiltered ? ` (Total: ${unfiltered})` : ''}
        </div>
      </div>
      <Pagination
        total={total}
        className={backColor === undefined ? '' : backColor}
        defaultPageSize={defaultPageSize}
        pageSizeOptions={pageOptions}
        defaultCurrent={1}
        itemRender={itemRender}
        showSizeChanger
        current={current}
        locale={{ items_per_page: '' }}
        onChange={(page, pageSize) => {
          changePage(page, pageSize)
        }}
      />
    </div>
  )
}

export default PaginationTable
